import { SVGIconComponent } from './types';

export const HubTypeSpacesHub: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      d="M10.075 1.005c.51 0 .925.437.925.975v15.045c0 .538-.414.975-.925.975H2.924c-.496 0-.905-.414-.924-.936V1.936c.02-.522.428-.936.924-.936zM4.309 2.167l2.288 2.009a.58.58 0 0 1 .29.51q.005 4.817.003 9.633c0 .24-.139.447-.337.535l-2.244 1.984h5.588V2.167zM14.6 5a.4.4 0 0 1 .4.4v3.816a.4.4 0 0 1-.4.4l-.35-.001V9.8a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-.185h-.35a.4.4 0 0 1-.4-.4V5.4a.4.4 0 0 1 .4-.4z"
    />
  </svg>
);
